// export const API_URL = "http://localhost:8080";
// export const API_URL = "https://proxy.cors.sh/" + "http://13.50.26.213:8080";
// export const API_URL =
// "https://cors-anywhere.herokuapp.com/" + "http://13.50.26.213:8080";
// export const API_URL = "http://24.144.69.54:8080/api/v1";
// export const API_URL = "http://170.64.251.113:8080/api/v1";
// export const API_URL = "http://localhost:8080/api/v1";

import { format } from "date-fns";

const normalizeApiUrl = (url) => url?.replace(/\/+$/, "");

export const API_URL = normalizeApiUrl(process.env.REACT_APP_API_URL);
export const API_URL_PUBLIC =
  normalizeApiUrl(process.env.REACT_APP_API_URL_PUBLIC) ||
  normalizeApiUrl(process.env.REACT_APP_API_URL)?.replace(/\/v1$/, "");
export const API_URL_EMPLOYEE = process.env.REACT_APP_TIMESHEET_API;

export const currency = "$  ";
export const GST = 10;

export const modules = [
  { label: "Client", value: "Client" },
  { label: "RPL", value: "RPL" },
  { label: "Skill Assessments", value: "Skill Assessments" },
  { label: "Admission", value: "Admission" },
  { label: "Visa", value: "Visa" },
  { label: "Insurance", value: "Insurance" },
  { label: "Other", value: "Other" },
];

export const visaTabs = [
  { label: "All", value: "All" },
  { label: "TR", value: "TR" },
  { label: "Student", value: "Student" },
  { label: "Dependent", value: "Dependent" },
  { label: "Visitor/Tourist", value: "Visitor/Tourist" },
  { label: "Bridging", value: "Bridging" },
  { label: "Others", value: "Others" },
];

export const groupedVisaOptions = [
  {
    name: "Electronic Travel Authority",
    group: "Visitor Visas",
    subclass: "601",
    label: "Electronic Travel Authority (601)",
  },
  {
    name: "eVisitor",
    group: "Visitor Visas",
    subclass: "651",
    label: "eVisitor (651)",
  },
  {
    name: "Transit Visa",
    group: "Visitor Visas",
    subclass: "771",
    label: "Transit Visa (771)",
  },
  {
    name: "Visitor Visa",
    group: "Visitor Visas",
    subclass: "600",
    label: "Visitor Visa (600)",
  },
  {
    name: "Work and Holiday Visa",
    group: "Visitor Visas",
    subclass: "462",
    label: "Work and Holiday Visa (462)",
  },
  {
    name: "Working Holiday Visa",
    group: "Visitor Visas",
    subclass: "417",
    label: "Working Holiday Visa (417)",
  },
  {
    name: "Student Visa",
    group: "Studying and Training Visas",
    subclass: "500",
    label: "Student Visa (500)",
  },
  {
    name: "Student Guardian Visa",
    group: "Studying and Training Visas",
    subclass: "590",
    label: "Student Guardian Visa (590)",
  },
  {
    name: "Training Visa",
    group: "Studying and Training Visas",
    subclass: "407",
    label: "Training Visa (407)",
  },
  {
    name: "Adoption Visa",
    group: "Family and Partner Visas",
    subclass: "102",
    label: "Adoption Visa (102)",
  },
  {
    name: "Aged Dependent Relative Visa",
    group: "Family and Partner Visas",
    subclass: "114",
    label: "Aged Dependent Relative Visa (114)",
  },
  {
    name: "Aged Dependent Relative Visa",
    group: "Family and Partner Visas",
    subclass: "838",
    label: "Aged Dependent Relative Visa (838)",
  },
  {
    name: "Aged Parent Visa",
    group: "Family and Partner Visas",
    subclass: "804",
    label: "Aged Parent Visa (804)",
  },
  {
    name: "Carer Visa",
    group: "Family and Partner Visas",
    subclass: "836",
    label: "Carer Visa (836)",
  },
  {
    name: "Carer Visa",
    group: "Family and Partner Visas",
    subclass: "116",
    label: "Carer Visa (116)",
  },
  {
    name: "Child Visa",
    group: "Family and Partner Visas",
    subclass: "101",
    label: "Child Visa (101)",
  },
  {
    name: "Child Visa",
    group: "Family and Partner Visas",
    subclass: "802",
    label: "Child Visa (802)",
  },
  {
    name: "Contributory Aged Parent (Temporary) Visa",
    group: "Family and Partner Visas",
    subclass: "884",
    label: "Contributory Aged Parent (Temporary) Visa (884)",
  },
  {
    name: "Contributory Aged Parent Visa",
    group: "Family and Partner Visas",
    subclass: "864",
    label: "Contributory Aged Parent Visa (864)",
  },
  {
    name: "Contributory Parent (Temporary) Visa",
    group: "Family and Partner Visas",
    subclass: "173",
    label: "Contributory Parent (Temporary) Visa (173)",
  },
  {
    name: "Contributory Parent Visa",
    group: "Family and Partner Visas",
    subclass: "143",
    label: "Contributory Parent Visa (143)",
  },
  {
    name: "Dependent Child Visa",
    group: "Family and Partner Visas",
    subclass: "445",
    label: "Dependent Child Visa (445)",
  },
  {
    name: "New Zealand Citizen Family Relationship (Temporary) Visa",
    group: "Family and Partner Visas",
    subclass: "461",
    label: "New Zealand Citizen Family Relationship (Temporary) Visa (461)",
  },
  {
    name: "Orphan Relative Visa",
    group: "Family and Partner Visas",
    subclass: "117",
    label: "Orphan Relative Visa (117)",
  },
  {
    name: "Orphan Relative Visa",
    group: "Family and Partner Visas",
    subclass: "837",
    label: "Orphan Relative Visa (837)",
  },
  {
    name: "Parent Visa",
    group: "Family and Partner Visas",
    subclass: "103",
    label: "Parent Visa (103)",
  },
  {
    name: "Partner (Provisional and Migrant) Visa",
    group: "Family and Partner Visas",
    subclass: "309/100",
    label: "Partner (Provisional and Migrant) Visa (309/100)",
  },
  {
    name: "Partner Visa",
    group: "Family and Partner Visas",
    subclass: "820/801",
    label: "Partner Visa (820/801)",
  },
  {
    name: "Prospective Marriage Visa",
    group: "Family and Partner Visas",
    subclass: "300",
    label: "Prospective Marriage Visa (300)",
  },
  {
    name: "Remaining Relative Visa",
    group: "Family and Partner Visas",
    subclass: "115",
    label: "Remaining Relative Visa (115)",
  },
  {
    name: "Remaining Relative Visa",
    group: "Family and Partner Visas",
    subclass: "835",
    label: "Remaining Relative Visa (835)",
  },
  {
    name: "Sponsored Parent (Temporary) Visa",
    group: "Family and Partner Visas",
    subclass: "870",
    label: "Sponsored Parent (Temporary) Visa (870)",
  },
  {
    name: "Business Innovation and Investment (Permanent) Visa",
    group: "Working and Skilled Visas",
    subclass: "888",
    label: "Business Innovation and Investment (Permanent) Visa (888)",
  },
  {
    name: "Business Innovation and Investment (Provisional) Visa",
    group: "Working and Skilled Visas",
    subclass: "188",
    label: "Business Innovation and Investment (Provisional) Visa (188)",
  },
  {
    name: "Business Owner Visa",
    group: "Working and Skilled Visas",
    subclass: "890",
    label: "Business Owner Visa (890)",
  },
  {
    name: "Global Talent Visa",
    group: "Working and Skilled Visas",
    subclass: "858",
    label: "Global Talent Visa (858)",
  },
  {
    name: "Employer Nomination Scheme",
    group: "Working and Skilled Visas",
    subclass: "186",
    label: "Employer Nomination Scheme (186)",
  },
  {
    name: "Investor Visa",
    group: "Working and Skilled Visas",
    subclass: "891",
    label: "Investor Visa (891)",
  },
  {
    name: "Permanent Residence (Skilled Regional) Visa",
    group: "Working and Skilled Visas",
    subclass: "191",
    label: "Permanent Residence (Skilled Regional) Visa (191)",
  },
  {
    name: "Regional Sponsored Migration Scheme",
    group: "Working and Skilled Visas",
    subclass: "187",
    label: "Regional Sponsored Migration Scheme (187)",
  },
  {
    name: "Skilled Employer Sponsored Regional (Provisional) Visa",
    group: "Working and Skilled Visas",
    subclass: "494",
    label: "Skilled Employer Sponsored Regional (Provisional) Visa (494)",
  },
  {
    name: "Skilled Independent Visa",
    group: "Working and Skilled Visas",
    subclass: "189",
    label: "Skilled Independent Visa (189)",
  },
  {
    name: "Skilled Nominated Visa",
    group: "Working and Skilled Visas",
    subclass: "190",
    label: "Skilled Nominated Visa (190)",
  },
  {
    name: "Skilled Regional (Provisional) Visa",
    group: "Working and Skilled Visas",
    subclass: "489",
    label: "Skilled Regional (Provisional) Visa (489)",
  },
  {
    name: "Skilled Regional Visa",
    group: "Working and Skilled Visas",
    subclass: "887",
    label: "Skilled Regional Visa (887)",
  },
  {
    name: "Skilled Work Regional (Provisional) Visa",
    group: "Working and Skilled Visas",
    subclass: "491",
    label: "Skilled Work Regional (Provisional) Visa (491)",
  },
  {
    name: "State or Territory Sponsored Business Owner Visa",
    group: "Working and Skilled Visas",
    subclass: "892",
    label: "State or Territory Sponsored Business Owner Visa (892)",
  },
  {
    name: "State or Territory Sponsored Investor Visa",
    group: "Working and Skilled Visas",
    subclass: "893",
    label: "State or Territory Sponsored Investor Visa (893)",
  },
  {
    name: "Temporary Activity Visa",
    group: "Working and Skilled Visas",
    subclass: "408",
    label: "Temporary Activity Visa (408)",
  },
  {
    name: "Temporary Graduate Visa",
    group: "Working and Skilled Visas",
    subclass: "485",
    label: "Temporary Graduate Visa (485)",
  },
  {
    name: "Temporary Work (International Relations) Visa",
    group: "Working and Skilled Visas",
    subclass: "403",
    label: "Temporary Work (International Relations) Visa (403)",
  },
  {
    name: "Temporary Work (Short Stay Specialist) Visa",
    group: "Working and Skilled Visas",
    subclass: "400",
    label: "Temporary Work (Short Stay Specialist) Visa (400)",
  },
  {
    name: "Skills in Demand Visa",
    group: "Working and Skilled Visas",
    subclass: "482",
    label: "Skills in Demand Visa (482)",
  },
  {
    name: "Global Special Humanitarian Visa",
    group: "Refugee and Humanitarian Visas",
    subclass: "202",
    label: "Global Special Humanitarian Visa (202)",
  },
  {
    name: "Protection Visa",
    group: "Refugee and Humanitarian Visas",
    subclass: "866",
    label: "Protection Visa (866)",
  },
  {
    name: "Refugee Visas",
    group: "Refugee and Humanitarian Visas",
    subclass: "200",
    label: "Refugee Visas (200)",
  },
  {
    name: "Refugee Visas",
    group: "Refugee and Humanitarian Visas",
    subclass: "201",
    label: "Refugee Visas (201)",
  },
  {
    name: "Refugee Visas",
    group: "Refugee and Humanitarian Visas",
    subclass: "203",
    label: "Refugee Visas (203)",
  },
  {
    name: "Refugee Visas",
    group: "Refugee and Humanitarian Visas",
    subclass: "204",
    label: "Refugee Visas (204)",
  },
  {
    name: "Temporary Protection Visa",
    group: "Refugee and Humanitarian Visas",
    subclass: "785",
    label: "Temporary Protection Visa (785)",
  },
  {
    name: "Safe Haven Enterprise Visa",
    group: "Refugee and Humanitarian Visas",
    subclass: "790",
    label: "Safe Haven Enterprise Visa (790)",
  },
  {
    name: "Resolution of Status Visa",
    group: "Refugee and Humanitarian Visas",
    subclass: "851",
    label: "Resolution of Status Visa (851)",
  },
  {
    name: "Bridging Visa A – BVA",
    group: "Other Visas",
    subclass: "010",
    label: "Bridging Visa A – BVA (010)",
  },
  {
    name: "Bridging Visa B – BVB",
    group: "Other Visas",
    subclass: "020",
    label: "Bridging Visa B – BVB (020)",
  },
  {
    name: "Bridging Visa C – BVC",
    group: "Other Visas",
    subclass: "030",
    label: "Bridging Visa C – BVC (030)",
  },
  {
    name: "Bridging Visa E – BVE",
    group: "Other Visas",
    subclass: "050",
    label: "Bridging Visa E – BVE (050)",
  },
  {
    name: "Bridging Visa E – BVE",
    group: "Other Visas",
    subclass: "051",
    label: "Bridging Visa E – BVE (051)",
  },
  {
    name: "Crew Travel Authority Visa",
    group: "Other Visas",
    subclass: "942",
    label: "Crew Travel Authority Visa (942)",
  },
  {
    name: "Former Resident Visa",
    group: "Other Visas",
    subclass: "151",
    label: "Former Resident Visa (151)",
  },
  {
    name: "Maritime Crew Visa",
    group: "Other Visas",
    subclass: "988",
    label: "Maritime Crew Visa (988)",
  },
  {
    name: "Medical Treatment Visa",
    group: "Other Visas",
    subclass: "602",
    label: "Medical Treatment Visa (602)",
  },
  {
    name: "Resident Return Visa",
    group: "Other Visas",
    subclass: "155",
    label: "Resident Return Visa (155)",
  },
  {
    name: "Resident Return Visa",
    group: "Other Visas",
    subclass: "157",
    label: "Resident Return Visa (157)",
  },
  {
    name: "Special Category Visa",
    group: "Other Visas",
    subclass: "444",
    label: "Special Category Visa (444)",
  },
  {
    name: "Special Purpose Visa",
    group: "Other Visas",
    subclass: "SPV",
    label: "Special Purpose Visa (SPV)",
  },
  {
    name: "Investor Retirement Visa",
    group: "Other Visas",
    subclass: "405",
    label: "Investor Retirement Visa (405)",
  },
];

export const programLevel = [
  { label: "Advanced Diploma", value: "Advanced Diploma" },
  { label: "Associate Degree", value: "Associate Degree" },
  { label: "Bachelor Degree", value: "Bachelor Degree" },
  { label: "Bachelor Honours Degree", value: "Bachelor Honours Degree" },
  { label: "Certificate I", value: "Certificate I" },
  { label: "Certificate II", value: "Certificate II" },
  { label: "Certificate III", value: "Certificate III" },
  { label: "Certificate IV", value: "Certificate IV" },
  { label: "Diploma", value: "Diploma" },
  { label: "Doctoral Degree", value: "Doctoral Degree" },
  { label: "Graduate Certificate", value: "Graduate Certificate" },
  { label: "Graduate Diploma", value: "Graduate Diploma" },
  { label: "Junior Secondary Studies", value: "Junior Secondary Studies" },
  { label: "Kindergarten Studies", value: "Kindergarten Studies" },
  {
    label: "Masters Degree (Coursework)",
    value: "Masters Degree (Coursework)",
  },
  { label: "Masters Degree (Extended)", value: "Masters Degree (Extended)" },
  { label: "Masters Degree (Research)", value: "Masters Degree (Research)" },
  { label: "Non AQF Award", value: "Non AQF Award" },
  { label: "Primary School Studies", value: "Primary School Studies" },
  {
    label: "Senior Secondary Certificate of Education",
    value: "Senior Secondary Certificate of Education",
  },
];

export const programType = [
  {
    label: "Natural and Physical Sciences",
    value: "Natural and Physical Sciences",
  },
  { label: "Information Technology", value: "Information Technology" },
  {
    label: "Engineering and Related Technologies",
    value: "Engineering and Related Technologies",
  },
  { label: "Architecture and Building", value: "Architecture and Building" },
  {
    label: "Agriculture, Environmental and Related Studies",
    value: "Agriculture, Environmental and Related Studies",
  },
  { label: "Health", value: "Health" },
  { label: "Education", value: "Education" },
  { label: "Management and Commerce", value: "Management and Commerce" },
  { label: "Society and Culture", value: "Society and Culture" },
  { label: "Creative Arts", value: "Creative Arts" },
  {
    label: "Food, Hospitality and Personal Services",
    value: "Food, Hospitality and Personal Services",
  },
  { label: "Mixed Field Programmes", value: "Mixed Field Programmes" },
];

export const visaWorkStatus = [
  { label: "Application Incomplete", value: "Application Incomplete" },
  { label: "Application Ready", value: "Application Ready" },
  { label: "Document Processing", value: "Document Processing" },
  { label: "Visa Lodged", value: "Visa Lodged" },
  { label: "Bridging Updated", value: "Bridging Updated" },
  { label: "Awaiting", value: "Awaiting" },
  { label: "Visa Waiting", value: "Visa Waiting" },
  { label: "Visa Approved", value: "Visa Approved" },
  { label: "Visa Rejected", value: "Visa Rejected" },
];

export const skillAssessmentWorkStatus = [
  { label: "Application Incomplete", value: "Application Incomplete" },
  { label: "Documents Collection", value: "Documents Collection" },
  { label: "Assessment Lodged", value: "Assessment Lodged" },
  { label: "Awaiting Outcome", value: "Awaiting Outcome" },
  { label: "Positive Outcome", value: "Positive Outcome" },
  { label: "Negative Outcome", value: "Negative Outcome" },
  { label: "Complete", value: "Complete" },
];

export const maritalStatusOptions = [
  { label: "Single", value: "Single" },
  { label: "Married", value: "Married" },
  { label: "Divorced", value: "Divorced" },
];

export const insurance_companies = [
  { label: "Medibank", value: "Medibank" },
  { label: "Allianz Care", value: "Allianz Care" },
  { label: "BUPA", value: "BUPA" },
  { label: "nib Health Insurance", value: "nib Health Insurance" },
  { label: "ahm Health Insurance", value: "ahm Health Insurance" },
];
export const insurance_cover_type = [
  { label: "Single", value: "Single" },
  { label: "Couple", value: "Couple" },
  { label: "Family", value: "Family" },
  { label: "Single Parent ", value: "Single Parent" },
];

export const insuranceWorkStatus = [
  { label: "Application Incomplete", value: "Application Incomplete" },
  { label: "Quote Requested", value: "Quote Requested" },
  { label: "Policy Purchased", value: "Policy Purchased" },
  { label: "Certificate Issued", value: "Certificate Issued" },
  { label: "Awaiting Documents", value: "Awaiting Documents" },
  { label: "Renewal Due", value: "Renewal Due" },
  { label: "Complete", value: "Complete" },
];
export const states = [
  { label: "New South Wales", value: "New South Wales" },
  { label: "Victoria", value: "Victoria" },

  { label: "Queensland", value: "Queensland" },
  { label: "Western Australia", value: "Western Australia" },
  { label: "South Australia", value: "South Australia" },
  { label: "Tasmania", value: "Tasmania" },
  {
    label: "Australian Capital Territory",
    value: "Australian Capital Territory",
  },
  {
    label: "Northern Territory",
    value: "Northern Territory",
  },
  {
    label: "Cantabury Darmin NT",
    value: "Cantabury Darmin NT",
  },
  {
    label: "New Castle",
    value: "New Castle",
  },
  {
    label: "Other",
    value: "Other",
  },
];

export const months = [
  {
    label: "Jan",
    value: "Jan",
  },
  {
    label: "Feb",
    value: "Feb",
  },
  {
    label: "March",
    value: "March",
  },
  {
    label: "April",
    value: "April",
  },
  {
    label: "May",
    value: "May",
  },
  {
    label: "June",
    value: "June",
  },
  {
    label: "July",
    value: "July",
  },
  {
    label: "Aug",
    value: "Aug",
  },
  {
    label: "Sept",
    value: "Sept",
  },
  {
    label: "Oct",
    value: "Oct",
  },
  {
    label: "Nov",
    value: "Nov",
  },
  {
    label: "Dec",
    value: "Dec",
  },
];
//  GTE applied, GtE approved, Gte Rejeected, Applied for COE, COE Receive, VISA Applied, Admission Successful

export const studentStatus = [
  {
    label: "Incomplete Application",
    value: "Incomplete Application",
  },
  {
    label: "Application Ready",
    value: "Application Ready",
  },
  { label: "Offer Letter Applied", value: "offer_letter_applied" },
  { label: "Offer Letter Received", value: "offer_letter_received" },
  { label: "GTE Applied", value: "gte_applied" },
  { label: "GTE Approved", value: "gte_approved" },
  { label: "GTE Rejected", value: "gte_rejected" },
  { label: "COE Applied", value: "coe_applied" },
  { label: "COE Rejected", value: "coe_rejected" },
  { label: "COE Received", value: "coe_rejected" },
  { label: "Visa Applied", value: "visa_applied" },
  { label: "Visa Granted", value: "visa_granted" },
  { label: "Visa Rejected", value: "visa_rejected" },
  { label: "Admission Successful", value: "admission_successful" },
  { label: "Application Complete", value: "application_complete" },
];

export const onShoreStudentStatus = [
  {
    label: "Incomplete Application",
    value: "Incomplete Application",
  },
  {
    label: "Application Ready",
    value: "Application Ready",
  },
  { label: "Offer Letter Applied", value: "offer_letter_applied" },
  { label: "Offer Letter Received", value: "offer_letter_received" },
  { label: "COE Applied", value: "coe_applied" },
  { label: "COE Received", value: "coe_rejected" },
];

export const monthsForFilter = [
  { label: "January", value: "January" },
  { label: "February", value: "February" },
  { label: "March", value: "March" },
  { label: "April", value: "April" },
  { label: "May", value: "May" },
  { label: "June", value: "June" },
  { label: "July", value: "July" },
  { label: "August", value: "August" },
  { label: "September", value: "September" },
  { label: "October", value: "October" },
  { label: "November", value: "November" },
  { label: "December", value: "December" },
];
export const rpl_status = [
  {
    label: "Incomplete Application",
    value: "Incomplete Application",
  },
  {
    label: "Application Ready",
    value: "Application Ready",
  },
  {
    label: "Enrollment Applied",
    value: "Enrollment Applied",
  },
  {
    label: "Enrollment Received",
    value: "Enrollment Received",
  },
  {
    label: "Placement Waiting",
    value: "Placement Waiting",
  },
  {
    label: "Placement Processing",
    value: "Placement Processing",
  },
  { label: "Ready to Apply", value: "Ready to Apply" },
  {
    label: "Certificate Processing",
    value: "Certificate Processing",
  },
  {
    label: "Certificate Ready",
    value: "Certificate Ready",
  },

  {
    label: "Payment Completed",
    value: "Payment Completed",
  },
  { label: "Softcopy sent", value: "Softcopy sent" },
  { label: "Hardcopy sent", value: "Hardcopy sent" },
  {
    label: "Cancelled",
    value: "Cancelled",
  },
];

export const documentForPlacement = [
  {
    label: "Covid Vaccination Certificate (Australian Converted)",
    value: "covid",
  },
  { label: "Flu Vaccination", value: "flu" },
  { label: "Police Check", value: "police_check" },
  { label: "NDIS Worker Check(if Asked)", value: "ndis" },
  { label: "WWVP( For Canberra Client only)", value: "wwvp" },
  {
    label: "NHHI Certificate (from the link available on Handbook Provided By Us)",
    value: "nhhi",
  },
  {
    label: "NDIS Worker orientation (from the link available on Handbook Provided By Us)",
    value: "ndis",
  },
];

export const studentInitialValue = {
  client: "",
  studentId: "",
  course: "",
  courseId: null,
  university: "",
  universityId: null,
  state: "",
  intake: "",
  agentName: "",
  startDate: format(new Date(), "yyyy-MM-dd"),
  endDate: format(new Date(), "yyyy-MM-dd"),
  totalFees: 0,
  agreedFees: 0,
  discount: 0,
  materialFee: 0,
  enrolmentFee: 0,
  semester: 0,
  perSemFee: 0,
  terms: "",
};
